import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/date-pickers/digital-clock/digital-clock.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
